export const DEFAULT_GOLD_RATE_PER_GRAM = 14201;

export function parseGramInput(value) {
  if (value === "" || value == null) return 0;
  const n = parseFloat(String(value).replace(/,/g, "").trim());
  return Number.isFinite(n) && n >= 0 ? n : 0;
}

export function calculateTotalOrnamentNetGrams(ornaments) {
  if (!Array.isArray(ornaments)) return 0;
  return ornaments.reduce((sum, row) => {
    const net = parseGramInput(row.net);
    const units = Number(row.units) || 1;
    return sum + net * units;
  }, 0);
}

export function calculateTenure(startDate, endDate) {
  if (!startDate || !endDate) return 0;
  const start = new Date(`${startDate}T00:00:00`);
  const end = new Date(`${endDate}T00:00:00`);
  const diffMs = end.getTime() - start.getTime();
  if (diffMs <= 0) return 0;
  return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
}

export function calculateInterest(loanAmount, interestPercent, tenureDays) {
  const principal = Number(loanAmount);
  const rate = Number(interestPercent);
  if (!principal || principal <= 0) return 0;
  if (rate < 0) return 0;
  // Apply flat percentage over the amount to match system logic
  return Math.round((principal * (rate / 100)) * 100) / 100;
}

export function calculateOrnamentAmount(netWeightGrams, goldRatePerGram) {
  const net = Number(netWeightGrams);
  const rate = Number(goldRatePerGram);
  if (Number.isNaN(net) || net < 0 || Number.isNaN(rate) || rate < 0) return 0;
  return Math.round(net * rate * 100) / 100;
}

export function calculateTotal(ornaments, goldRatePerGram) {
  if (!Array.isArray(ornaments)) return 0;
  return ornaments.reduce(
    (sum, row) => sum + calculateOrnamentAmount(row.net, goldRatePerGram),
    0
  );
}

export function calculateTotalPayable(loanAmount, interestAmount) {
  const p = Number(loanAmount) || 0;
  const i = Number(interestAmount) || 0;
  return Math.round((p + i) * 100) / 100;
}

// format currency in Rs not in ₹
export function formatCurrencyINR(value) {
  const n = Number(value);

  if (value === "" || value == null || Number.isNaN(n)) {
    return "Rs 0.00";
  }

  const formatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter
    .formatToParts(n)
    .map(part => part.type === "currency" ? "Rs. " : part.value)
    .join("");
}

export function formatDateDDMMYYYY(isoDateString) {
  if (!isoDateString || typeof isoDateString !== "string") return "";
  const parts = isoDateString.split("-");
  if (parts.length !== 3) return isoDateString;
  const [y, m, d] = parts;
  return `${d}-${m}-${y}`;
}

